import { useField } from 'formik';
import { useState } from 'react';
import styled from 'styled-components';
import { InputTextarea } from 'primereact/inputtextarea';
import { Tooltip } from 'react-tooltip';

const TextAreaInputStyled = styled(InputTextarea)`
    width: 100%;
    height: ${({ size }) => (size === 'small' ? '80px' : '140px')};
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 12px;
    resize: none;
    &:focus {
        background-color: lightblue;
        outline: none;
    }
`;

const Div = styled.div`
    color: red;
`;

const Label = styled.label`
    font-weight: bold;
    display: flex;
    align-items: center;
`;

const Asterisk = styled.span`
    color: red;
    margin-left: 5px;
`;

const CharacterCount = styled.div`
    text-align: right;
    font-size: 12px;
    color: #555;
    margin-top: 5px;
`;

const TextArea = ({ label, tooltipContent, required, maxLength = 700, size, ...props }) => {
    const [field, meta, helpers] = useField(props);
    const [charCount, setCharCount] = useState(field.value?.length || 0);

    const handleChange = (e) => {
        const value = e.target.value;
        if (value.length <= maxLength) {
            helpers.setValue(value);
            setCharCount(value.length);
        }
    };

    return (
        <div>
            <Label>
                {label}
                {required && <Asterisk>*</Asterisk>}
            </Label>
            <TextAreaInputStyled
                {...field}
                value={field.value || ""}
                onChange={handleChange}
                data-tooltip-id="my-tooltip-multiline"
                data-tooltip-html={tooltipContent}
                size={size}
            />
            <Tooltip id="my-tooltip-multiline" />
            <CharacterCount>{charCount}/{maxLength}</CharacterCount>
            {meta.touched && meta.error ? <Div>{meta.error}</Div> : null}
        </div>
    );
};

export default TextArea;
